import { ReactElement } from 'react';

import {
   ReceptionServiceWithPractitionersSimple,
   ReceptionServiceWithPractitionersSimpleQuery,
} from '@dreryk/egabinet-private-medical-service-frontend-api';

import { CqrsQueryPerformResult, performCqrsQuerySearch } from '@dreryk/command-query-react-common';
import { createTranslatedText } from '@dreryk/react-common';
import { Select } from '@dreryk/react-components';
import { TextPattern } from '@dreryk/watermelon';

import { medicalServicesMappingsTranslationKeys } from '../../../translations';

import { DocplannerServiceMappingCreateFormController } from './docplannerServiceMappingCreate.types';

const receptionServiceWithPractitionerSearchCreator = (searchText: string | null) => {
   return async (): CqrsQueryPerformResult<ReceptionServiceWithPractitionersSimple[]> =>
      performCqrsQuerySearch<ReceptionServiceWithPractitionersSimple>(() => {
         const receptionServiceWithPractitionersSimpleQuery = new ReceptionServiceWithPractitionersSimpleQuery();
         receptionServiceWithPractitionersSimpleQuery.name = searchText
            ? TextPattern.anywhereIgnoreCase(searchText)
            : undefined;
         return receptionServiceWithPractitionersSimpleQuery;
      });
};

const triggerLabelExtractor = (receptionService: ReceptionServiceWithPractitionersSimple): string =>
   receptionService.name;

type ReceptionServiceSelectProps = {
   readonly register: DocplannerServiceMappingCreateFormController['register'];
};

export const ReceptionServiceSelect = (props: ReceptionServiceSelectProps): ReactElement => {
   return (
      <Select<ReceptionServiceWithPractitionersSimple>
         testId={'receptionService'}
         triggerLabelExtractor={triggerLabelExtractor}
         controller={props.register('receptionService', { required: true })}
         placeholder={medicalServicesMappingsTranslationKeys.chooseReceptionService}
         label={medicalServicesMappingsTranslationKeys.receptionService}
         searchInputEnabled
      >
         <Select.SearchCreator searchCreator={receptionServiceWithPractitionerSearchCreator}>
            {({ items: services }) => (
               <Select.List<ReceptionServiceWithPractitionersSimple> items={services} keyExtractor={'id'}>
                  {(service) => (
                     <Select.Item
                        item={service}
                        testId={service.id.asNumber()}
                        label={<Select.Highlight node={createTranslatedText(service.name)} />}
                     />
                  )}
               </Select.List>
            )}
         </Select.SearchCreator>
      </Select>
   );
};
